/**
 * 監視設定向けの除外キーワードをエラーメッセージに含んだものを返却する。
 * @param origin - wrap対象のメッセージ
 * @param level - アラートレベル
 */
export const wrapMessage = (origin: string, level: AlertKeyWordType = 'INFO') => `${origin}${ALERT_KEY_WORD[level]}`;

const ALERT_KEY_WORD = {
  INFO: ':info',
  WARN: ':warning',
  QUIET_WARN: ':quiet_warning',
};

type AlertKeyWordType = keyof typeof ALERT_KEY_WORD;
